export default [
  {
    path: "signin",
    component: () => import("@/views/Users/Signin/index.vue"),
  },
  {
    path: "find-account",
    component: () => import("@/views/Users/Find-account/index.vue"),
  },
  {
    path: "find-id",
    component: () => import("@/views/Users/Find-id/index.vue"),
  },
  {
    path: "update-pw",
    component: () => import("@/views/Users/Find-pw/index.vue"),
  },
];
